import { render, staticRenderFns } from "./partner-card.component.vue?vue&type=template&id=9b721052&scoped=true"
import script from "./partner-card.component.vue?vue&type=script&lang=js"
export * from "./partner-card.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b721052",
  null
  
)

export default component.exports